import * as React from "react";
import {DEF} from "../../../const";
import Box from "@mui/material/Box";
import {useEffect} from "react";
import "./SuccessInfo.css"


export const SuccessInfoState = {
    msg: '',
    show: DEF.POPUP_SHOWING_DEFAULT_TIME,
    timer: null,
}

export const SuccessInfo = (
    {
        state,// SuccessInfoState
        setState
    }
) => {
    useEffect(() => {
        if(state.timer) {
            clearTimeout(state.timer);
        }
        if (DEF.POPUP_SHOWING_MANUAL_CLOSE !== state.show)
        {
            if (state.msg) {
                const timer = setTimeout(() => {
                    setState(SuccessInfoState);
                }, state.show);
                setState(state => ({...state, timer: timer}));
            } else {
                setState(SuccessInfoState);
            }
        } else {
            if (!state.msg) {
                setState(SuccessInfoState);
            }
        }
    }, [state.msg]);

    return (
        <Box className='success-info'>
            <Box className='success-info-frame' role='success-info-frame'>
                {(DEF.POPUP_SHOWING_MANUAL_CLOSE === state.show) && (
                    <button className='button'
                        onClick={() => setState(state => ({...state, msg: ''}))}
                    >
                        x
                    </button>
                )}

                {state.msg}
            </Box>
        </Box>
    );
};

export default SuccessInfo;